import React, { memo } from 'react'
import './Button.scss'

const Button = (props) => {
  const { children, className = 'btn-primary', onClick, disabled, ...rest } = props
  return <button type='button' className={`btn ${className}`} onClick={onClick} disabled={disabled} {...rest}> {children} </button>
}
export default memo(Button)
